import React, { lazy, Suspense } from 'react';

import UniqueId from '../../../services/uid/UniqueId';
import { ContentEntityType } from '../../../store/slices/content';
import CategoryContainer from '../category/CategoryContainer';

const BalanceContainer = lazy(() => import('../balance/BalanceContainer'));

interface Props {
  contentType: ContentEntityType;
  contentId: UniqueId;
}

const ContentEntity: React.FC<Props> = ({ contentType, contentId }) => {
  switch (contentType) {
    case ContentEntityType.CATEGORY:
      return <CategoryContainer id={contentId} showCommands />;
    case ContentEntityType.BALANCE_FORM:
      return (
        <Suspense>
          <BalanceContainer id={contentId} />
        </Suspense>
      );
    default:
      return null;
  }
};

export default ContentEntity;
